import { types } from 'mobx-state-tree';

import { getOptions } from '../flows/get-options';

const PassolutionOption = types.model({
  name: types.string,
  code: types.string,
});

export const PassolutionOptions = types
  .model('PassolutionOptions', {
    nationalities: types.array(PassolutionOption),
    destinations: types.array(PassolutionOption),
  })
  .actions((self) => ({
    fetch: (language) => getOptions(self, language),
    findDestinationCodeByName: (name) =>
      self.destinations.find(
        (destination) => destination.name.toLowerCase() === name.toLowerCase(),
      )?.code || '',
  }));
